module.exports = __webpack_public_path__ + "img/fibra_superior_e_inferior.8a942abd.jpg";